"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcFooterBehavior = void 0;
var default_behavior_1 = require("../../../common/models/default-behavior");
var footer_constants_1 = require("./footer-constants");
var footer_constants_2 = require("./footer-constants");
var footer_constants_3 = require("./footer-constants");
var footer_constants_4 = require("./footer-constants");
var footer_constants_5 = require("./footer-constants");
var footer_constants_6 = require("./footer-constants");
var footer_constants_7 = require("./footer-constants");
var footer_constants_8 = require("./footer-constants");
var footer_constants_9 = require("./footer-constants");
var footer_constants_10 = require("./footer-constants");
var footer_constants_11 = require("./footer-constants");
var footer_constants_12 = require("./footer-constants");
var footer_constants_13 = require("./footer-constants");
var footer_constants_14 = require("./footer-constants");
var footer_constants_15 = require("./footer-constants");
var footer_constants_16 = require("./footer-constants");
var footer_constants_17 = require("./footer-constants");
var footer_constants_18 = require("./footer-constants");
var footer_constants_19 = require("./footer-constants");
var footer_constants_20 = require("./footer-constants");
var footer_constants_21 = require("./footer-constants");
var footer_constants_22 = require("./footer-constants");
var helpers_1 = require("../../../common/helpers");
var bc_accordion_behavior_1 = require("../../molecules/bc-accordion/bc-accordion-behavior");
var BcFooterBehavior = (function (_super) {
    __extends(BcFooterBehavior, _super);
    function BcFooterBehavior() {
        var _this = _super.call(this) || this;
        _this.bcFooterIsMobile = false;
        return _this;
    }
    BcFooterBehavior.setUpAll = function () {
        var inputElements = Array.from(document.querySelectorAll("div[class~='".concat(footer_constants_2.BC_FOOTER_SELECTOR, "']")));
        var elements = [];
        for (var _i = 0, inputElements_1 = inputElements; _i < inputElements_1.length; _i++) {
            var inputElement = inputElements_1[_i];
            var bcFooterBehavior = new BcFooterBehavior();
            bcFooterBehavior.setElement(inputElement);
            bcFooterBehavior.setUp();
            elements.push(bcFooterBehavior);
        }
        return elements;
    };
    BcFooterBehavior.prototype._setUp = function () {
        this.selectElements();
        this.addAccesibility();
        this.validateBreakPointMobile();
    };
    BcFooterBehavior.prototype.selectElements = function () {
        this.bcFooterElementTop = this.mySelf.querySelector(".".concat(footer_constants_1.BC_FOOTER_TOP));
        this.bcFooterElementTopCont = this.bcFooterElementTop
            ? Array.from(this.bcFooterElementTop.children) : null;
        this.bcFooterIconNetwork = this.mySelf.querySelector(".".concat(footer_constants_3.BC_FOOTER_NETWORK_ICONS));
        this.bcFooterIconNetworkChildren = this.bcFooterIconNetwork
            ? Array.from(this.bcFooterIconNetwork.children) : [];
        this.bcFooterElementsTopT = Array.from(this.mySelf.querySelectorAll(".".concat(footer_constants_5.BC_FOOTER_TOP_CONTAINER_T)));
        this.bcFooterElementsTopP = Array.from(this.mySelf.querySelectorAll(".".concat(footer_constants_6.BC_FOOTER_TOP_CONTAINER_P)));
        this.bcFooterElementsTopTA = Array.from(this.mySelf.querySelectorAll(".".concat(footer_constants_5.BC_FOOTER_TOP_CONTAINER_T, " ").concat(footer_constants_7.BC_FOOTER_P, " ").concat(footer_constants_8.BC_FOOTER_A)));
        this.bcfooterElementsTopPA = Array.from(this.mySelf.querySelectorAll(".".concat(footer_constants_6.BC_FOOTER_TOP_CONTAINER_P, " ").concat(footer_constants_7.BC_FOOTER_P, " ").concat(footer_constants_8.BC_FOOTER_A)));
        this.bcFooterElementsLA = Array.from(this.mySelf.querySelectorAll(".".concat(footer_constants_11.BC_FOOTER_TOP_LA)));
        this.bcfooterAccordions = Array.from(this.mySelf.querySelectorAll("div[class~='".concat(footer_constants_13.BC_FOOTER_ACCORDION_CLASS, "']")));
    };
    BcFooterBehavior.prototype.addAccesibility = function () {
        this.addAcceSocialNet();
        this.addAcceLinks();
    };
    BcFooterBehavior.prototype.addAcceSocialNet = function () {
        for (var _i = 0, _a = this.bcFooterIconNetworkChildren; _i < _a.length; _i++) {
            var e = _a[_i];
            (0, helpers_1.addFocusable)(e, { label: "Ir a ".concat(e.firstElementChild.innerHTML) });
        }
    };
    BcFooterBehavior.prototype.addAcceLinks = function () {
        this.addAcceLink(footer_constants_9.BC_FOOTER_ELEMENTS_TOPTA);
        this.addAcceLink(footer_constants_10.BC_FOOTER_ELEMENTS_TOPPA);
        this.addAcceLink(footer_constants_12.BC_FOOTER_ELEMENTS_LA);
    };
    BcFooterBehavior.prototype.addAcceLink = function (href) {
        var _this = this;
        this[href].forEach(function (elemA) {
            _this.addFocusableLink(elemA);
        });
    };
    BcFooterBehavior.prototype.addFocusableLink = function (elem) {
        (0, helpers_1.addFocusable)(elem, { label: "Ir a ".concat(elem.innerHTML) });
    };
    BcFooterBehavior.prototype.getFooterTopELements = function () {
        return Array.from(this.mySelf.querySelectorAll("div[class~='".concat(footer_constants_4.BC_FOOTER_TOP_CONTAINERS, "']")));
    };
    BcFooterBehavior.prototype.validateBreakPointMobile = function () {
        var _this = this;
        var validateSizeWidth = function () {
            if ((window.innerWidth <= footer_constants_14.BC_FOOTER_MOBILE_BREAK_POINT && !_this.bcFooterIsMobile)) {
                _this.addAccordion();
            }
        };
        window.addEventListener('load', function () {
            validateSizeWidth();
        });
        window.addEventListener('resize', function () {
            validateSizeWidth();
        });
    };
    BcFooterBehavior.prototype.addAccordion = function () {
        var _this = this;
        this.bcFooterIsMobile = true;
        this.getFooterTopELements().forEach(function (element, index) {
            var textTitleList = element.querySelector(".".concat(footer_constants_5.BC_FOOTER_TOP_CONTAINER_T, " h6"));
            var textItemsList = Array.from(element.querySelectorAll(".".concat(footer_constants_6.BC_FOOTER_TOP_CONTAINER_P, " a")));
            var accordionGroupElement = _this.createAccordionGroupELement(index);
            var accordionElement = _this.createAccordionELement();
            var accordionHeaderElement = _this.createAccordionHeaderELement(textTitleList, textItemsList.length);
            var accordionContentElement = _this.createAccordionContentELement(textItemsList);
            accordionElement.appendChild(accordionHeaderElement);
            accordionElement.appendChild(accordionContentElement);
            accordionGroupElement.appendChild(accordionElement);
            element.appendChild(accordionGroupElement);
            bc_accordion_behavior_1.BcAccordionBehavior.setUpAll();
        });
    };
    BcFooterBehavior.prototype.createAccordionGroupELement = function (index) {
        var accordionGroupElement = document.createElement('div');
        accordionGroupElement.classList.add(footer_constants_15.BC_FOOTER_ACCORDIONS_GROUP);
        accordionGroupElement.setAttribute('id', this.mySelf.getAttribute('id') + index);
        return accordionGroupElement;
    };
    BcFooterBehavior.prototype.createAccordionELement = function () {
        var accordionElement = document.createElement('div');
        accordionElement.classList.add(footer_constants_16.BC_FOOTER_ACCORDION);
        accordionElement.classList.add(footer_constants_17.BC_FOOTER_ACCORDION_TYPE);
        return accordionElement;
    };
    BcFooterBehavior.prototype.createAccordionHeaderELement = function (titleHeader, numberItems) {
        var accordionHeaderElement = document.createElement('div');
        accordionHeaderElement.classList.add(footer_constants_18.BC_FOOTER_ACCORDION_HEADER);
        var templateHeaderRight = numberItems > 0 ?
            "<div class=\"".concat(footer_constants_20.BC_FOOTER_ACCORDION_HEADER_RIGHT, "\">\n      <em class=\"bc-icon bc-sm bc-toggle-button\">arrow2-down</em>\n    </div>\n    ") : '';
        var templateHeader = "\n    <div class=\"".concat(footer_constants_19.BC_FOOTER_ACCORDION_HEADER_LEFT, "\">\n      <div class=\"").concat(footer_constants_21.BC_FOOTER_ACCORDION_TEXT_CONTAINER, "\">\n      </div>\n    </div>\n    ").concat(templateHeaderRight, "\n    ");
        accordionHeaderElement.innerHTML = templateHeader;
        accordionHeaderElement.querySelector(".".concat(footer_constants_21.BC_FOOTER_ACCORDION_TEXT_CONTAINER)).append(titleHeader.cloneNode(true));
        return accordionHeaderElement;
    };
    BcFooterBehavior.prototype.createAccordionContentELement = function (items) {
        var accordionContentElement = document.createElement('div');
        accordionContentElement.classList.add(footer_constants_22.BC_FOOTER_ACCORDION_CONTENT);
        items.forEach(function (item) {
            accordionContentElement.appendChild(item.cloneNode(true));
        });
        return accordionContentElement;
    };
    BcFooterBehavior.prototype.createParameterizationStrokeColors = function (colors) {
        var svg = this.mySelf.querySelector('#bc-footer-stroke');
        for (var propiedad in colors) {
            var pathElement = svg.querySelector('#' + propiedad);
            pathElement.setAttribute('fill', colors[propiedad]);
        }
    };
    return BcFooterBehavior;
}(default_behavior_1.BcDefaultBehavior));
exports.BcFooterBehavior = BcFooterBehavior;
